import axios from "axios";
import store from "@/store";
import { message } from "antd";
import i18next from "i18next";
let errorMap = {};
let errorMsg = (msg = "") => {
  if (!msg) return;
  if (errorMap[msg]) return;
  errorMap[msg] = message.error(msg || "request failure", () => {
    delete errorMap[msg];
  });
};
class HttpRequest {
  constructor(responseType = "json") {
    this.timeout = 60000;
    this.headers = {
      "Content-Type": "application/json;charset=utf-8",
    };
    this.withCredentials = false;
    this.responseType = responseType;
    this.transformResponse = [
      (data) => {
        data = JSON.parse(data);
        return data;
      },
    ];
    this.instance = axios.create({
      timeout: this.timeout,
      headers: this.headers,
      withCredentials: this.withCredentials,
      responseType: this.responseType,
      transformResponse: this.transformResponse,
    });

    this.instance.interceptors.request.use(
      (config) => {
        config.headers = config.headers;
        const token =
          sessionStorage.getItem("token") || localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = token;
        }
        let { language } = store.getState();
        config.headers["Accept-Language"] = language;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  request(config) {
    store.dispatch({ type: "showLoading" });

    return new Promise((resolve, reject) => {
      this.instance
        .request(config)
        .then((response) => {
          let data = response.data;
          if (data.code === 200 || data.statusCode === 200) {
            resolve(data.data);
            if (
              (config.method === "post" || config.method === "put") &&
              config.toast !== false
            ) {
              if (data.msg) {
                message.success(data.msg);
              }
            }
          } else if (data.code === 401) {
            errorMsg(data.msg || "request failure");
            window.location.href = "/nft.html#/login";
            store.dispatch({ type: "changeIsLogin", isLogin: false });
            reject(new Error(data.msg || "request failure"));
          } else if (data.statusCode === 40001) {
            errorMsg(i18next.t("error1") || "request failure");
            reject(new Error(i18next.t("error1") || "request failure"));
          } else if (data.statusCode === 40002) {
            errorMsg(i18next.t("error2") || "request failure");
            reject(new Error(i18next.t("error2") || "request failure"));
          } else if (data.statusCode === 40003) {
            errorMsg(i18next.t("error3") || "request failure");
            reject(new Error(i18next.t("error3") || "request failure"));
          } else if (
            data.statusCode === 4001 ||
            data.statusCode === 4002 ||
            data.code === 4001 ||
            data.code === 4002
          ) {
            resolve(data);
          } else {
            errorMsg(data.msg || "request failure");
            reject(new Error(data.msg || "request failure"));
          }
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            errorMsg(error.response.data.msg);
            window.location.href = "/nft.html#/login";
            store.dispatch({ type: "changeIsLogin", isLogin: false });
          }
          reject(error);
        })
        .finally(() => {
          store.dispatch({ type: "hideLoading" });
        });
    });
  }

  get(url, params, config) {
    return this.request({
      method: "get",
      url: `/api${url}`,
      params,
      ...config,
    });
  }

  post(url, data, config) {
    return this.request({
      method: "post",
      url: `/api${url}`,
      data,
      ...config,
    });
  }

  put(url, data, config) {
    return this.request({
      method: "put",
      url: `/api${url}`,
      data,
      ...config,
    });
  }

  delete(url, config) {
    return this.request({
      method: "delete",
      url: `/api${url}`,
      ...config,
    });
  }

  getnft(url, params, config) {
    return this.request({
      method: "get",
      url: `/nft${url}`,
      params,
      ...config,
    });
  }

  postnft(url, data, config) {
    return this.request({
      method: "post",
      url: `/nft${url}`,
      data,
      ...config,
    });
  }
}

export default new HttpRequest();
